import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["breadcrumbs", "title", "description", "layoutType", "buttons", "className", "backgroundColor", "showBottomPadding", "contentAlign"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { Layout } from '@sbercloud/uikit-product-site-layout';
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Breadcrumbs } from '@snack-uikit/breadcrumbs';
import { ButtonFilled } from '@snack-uikit/button';
import { Typography } from '@snack-uikit/typography';
import { HERO_COLORS } from '../../constants';
import styles from "./styles.module.css";
import { getTitleTypographyProps } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function HeroZero(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    title = _ref.title,
    description = _ref.description,
    layoutType = _ref.layoutType,
    buttons = _ref.buttons,
    className = _ref.className,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? HERO_COLORS.NeutralBackground : _ref$backgroundColor,
    _ref$showBottomPaddin = _ref.showBottomPadding,
    showBottomPadding = _ref$showBottomPaddin === void 0 ? true : _ref$showBottomPaddin,
    _ref$contentAlign = _ref.contentAlign,
    contentAlign = _ref$contentAlign === void 0 ? 'left' : _ref$contentAlign,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Layout.SectionWrapper, _objectSpread(_objectSpread({
    layoutType: layoutType,
    className: cn(className, styles.sectionWrapper),
    "data-section-background": backgroundColor
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: cn(styles.heroZero, _defineProperty({}, styles.withBottomPadding, showBottomPadding)),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.contentLayout,
        "data-layout-type": layoutType,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.contentText,
          "data-layout-type": layoutType,
          children: [/*#__PURE__*/_jsx(Breadcrumbs, {
            items: breadcrumbs,
            size: "xs"
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.text,
            "data-layout-type": layoutType,
            "data-align": contentAlign,
            children: [/*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
              family: "sans",
              tag: "h1",
              className: styles.title
            }, getTitleTypographyProps(layoutType)), {}, {
              children: title
            })), description && /*#__PURE__*/_jsx(Typography.SansBodyL, {
              tag: "div",
              className: styles.description,
              children: /*#__PURE__*/_jsx(RichText, {
                richText: description
              })
            })]
          })]
        }), buttons && buttons.length > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.buttons,
          "data-layout-type": layoutType,
          "data-align": contentAlign,
          children: buttons.map(function (props, index) {
            return /*#__PURE__*/_jsx(ButtonFilled, _objectSpread(_objectSpread({
              className: styles.button
            }, props), {}, {
              "data-layout-type": layoutType
            }), index);
          })
        })]
      })
    })
  }));
}